import axios from "axios";
import { Base_URL } from "../url";

export const saveCustomerDetails = async (customerData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CustomerMaster/CustomerMaster?UserName=${username}`,
      customerData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving customer details!";
  }
};

export const getAllCustomerTypes = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CustomerType/GetAllCustomerTypes`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching customer types!";
  }
};

export const getCustomerData = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CustomerMaster/CustomerGetData`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching customer data!";
  }
};

export const getAllCustomerExternalIds = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CustomerExternalIds/GetAllCustomerExternalIds`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching customer external IDs!";
  }
};

export const getAllCountries = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CountryMaster/GetAllCountries`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching countries!";
  }
};

export const getRegionsByCountry = async (countryCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/RegionMaster/GetRegionsByCountry`,
      {
        countryCode: countryCode,
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching regions!";
  }
};

export const getDistrictsByRegion = async (regionCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/DistrictMaster/GetDistrictsByRegion`,
      {
        regionCode: regionCode,
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching districts!";
  }
};

export const getTehsilsByDistrict = async (districtCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TehsilMaster/GetTehsilsByDistrict`,
      {
        districtCode: districtCode,
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching tehsils!";
  }
};

export const getCitiesByTehsil = async (tehsilCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CityMaster/GetCitiesByTehsil`,
      {
        tehsilCode: tehsilCode,
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching cities!";
  }
};

export const getAllCurrencies = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CurrencyMaster/GetAllCurrencies`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching currencies!";
  }
};

export const getAllMerchants = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/MerchantMaster/GetAllMerchants/${id}`
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching merchants!";
  }
};

export const getAllResources = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/ResourceMasters`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};

// Get vendors by organisation ID
export const getVendorsByOrganisation = async (organisationId) => {
  try {
    const response = await fetch( `${Base_URL}/VendorMaster/?id=${organisationId}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching vendors:", error);
    throw error;
  }
};

export const getCompanyCodesByOrganisation = async (organisationId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CompanyCode/GetByOrganisationId`,
      {
        organisationId: organisationId
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching company codes!";
  }
};

export const getCustomerTypebyOrgId=async(id)=>{
  try {
    const response = await axios.get(
      `${Base_URL}/CustomerType/${id}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching company codes!";
  }
} 